<template>
    <div class="main-content jadwaldokter">
        <section class="fasilitas-containter">
            <div class="container">
                <div
                    class="section-content mt-30"
                    data-aos="fade-left"
                    data-aos-delay="300"
                >
                    <iframe
                        :src="jadwal_url"
                        frameborder="0"
                        border="0"
                        cellspacing="0"
                        style="
                            border-style: none;
                            width: 100%;
                            min-height: 700px;
                            max-height: 700px;
                        "
                    ></iframe>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    data() {
        return {
            jadwal_url: "https://antrian.rsuii.co.id/informasibed/default.aspx",
            show_loading: true,
            data: {},
            user_data: {},
        };
    },
    mounted() {},
    methods: {},
};
</script>



// WEBPACK FOOTER //
// src/pages/InfoAntrianBed.vue